




















import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbAlert, mdbIcon } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbAlert,
        mdbIcon
    },
    validations: {
        slug: {
            isValidSlug: (slug, model) => {
                if (typeof slug === 'undefined' || slug === null || slug === '') {
                    return true;
                }
                return /^[A-Za-z0-9\-\_]{3,32}$/.test(slug);
            }
        }
    }
})
export default class EditSlug extends Vue {
    @Prop(String) private slug?: string;
    @Prop(String) private warning?: string;
    @Prop(String) private help?: string;

    private hasErrors(): boolean {
        this.$v.slug.$touch();
        if (this.$v.slug.$error) {
            return true;
        }
        return false;
    }

    get dirtySlug(): string {
        return this.slug!;
    }

    set dirtySlug(value: string) {
        this.$emit('update:slug', value);
    }
}
